// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 992px) {
   /* desktop */
   .header {
      background-color: #fff;
      min-width: 500px;
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      height: 50px;
      padding: 0;
      z-index: 8;
   }
}

.notification {
   margin-right: 5px;
   cursor: pointer;
}

@media (min-width: 0px) and (max-width: 992px) {
   /* mobile */
   .header {
      background-color: #fff;
      position: fixed;
      left: 0;
      top: 0;
      height: 50px;
      padding: 0;
      z-index: 8;
      width: 100%;
   }
}

::ng-deep .login-page header {
   display: none;
   padding-top: 40px !important;
}

::ng-deep .no-header {
   background-color: #fafbfd;
}

::ng-deep .no-header .header {
   background-color: transparent;
}

::ng-deep .header-shadow .header {
   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

/* Browser Compatibility Warning Banner */
.browser-warning-banner {
   position: fixed;
   bottom: 0px;
   left: 0;
   right: 0;
   background: linear-gradient(135deg, #2ab4c0 0%, #007c9e 100%);
   color: #fff;
   z-index: 100000;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
   animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
   from {
      transform: translateY(100%);
      opacity: 0;
   }
   to {
      transform: translateY(0);
      opacity: 1;
   }
}

.browser-warning-content {
   display: flex;
   align-items: center;
   padding: 16px 24px;
   max-width: 1400px;
   margin: 0 auto;
}

.warning-icon {
   flex-shrink: 0;
   margin-right: 16px;
}

.warning-icon mat-icon {
   font-size: 32px;
   width: 32px;
   height: 32px;
   color: #fff8dc;
}

.warning-message {
   flex: 1;
   line-height: 1.5;
}

.warning-message strong {
   font-weight: 600;
   font-size: 16px;
   display: block;
   margin-bottom: 8px;
}

.warning-message p {
   margin: 0;
   font-size: 14px;
   opacity: 0.95;
}

.warning-message p strong {
   display: inline;
   margin: 0;
   color: #fff8dc;
   font-size: 14px;
}

.warning-close {
   flex-shrink: 0;
   background: transparent;
   border: none;
   color: #fff;
   cursor: pointer;
   padding: 8px;
   margin-left: 16px;
   border-radius: 50%;
   transition: background-color 0.2s ease;
   display: flex;
   align-items: center;
   justify-content: center;
}

.warning-close:hover {
   background-color: rgba(255, 255, 255, 0.15);
}

.warning-close mat-icon {
   font-size: 24px;
   width: 24px;
   height: 24px;
}

@media (max-width: 768px) {
   .browser-warning-content {
      padding: 12px 16px;
   }

   .warning-icon {
      margin-right: 12px;
   }

   .warning-icon mat-icon {
      font-size: 24px;
      width: 24px;
      height: 24px;
   }

   .warning-message strong {
      font-size: 14px;
      margin-bottom: 6px;
   }

   .warning-message p {
      font-size: 12px;
   }

   .warning-message p strong {
      font-size: 12px;
   }

   .warning-close {
      margin-left: 8px;
   }
}

.brand {
   height: 50px;
}

.brand .apps-button {
   background-color: #2ab4c0;
   color: #fff;
   cursor: pointer;
   width: 50px;
   height: 50px;
   transition: background-color 0.467s cubic-bezier(0.1, 0.9, 0.2, 1) 34ms;
   -webkit-user-select: none;
           user-select: none;
}

.brand .apps-button:hover {
   background-color: #007c9e;
}

.brand .logo {
   align-items: center;
}

.brand .logo img {
   height: 18px;
   margin: 3px 30px 0;
   outline: none;
   -webkit-user-select: none;
           user-select: none;
}

.brand .logo .separator {
   background-color: #e5e5e5;
   border-radius: 2px;
   width: 1px;
   height: 30px;
}

.brand .logo span {
   font-size: 20px;
   padding: 0 30px 0 20px;
}

.apps {
   padding: 8px 16px;
}

.apps a {
   border: 1px solid transparent;
   border-radius: 2px;
   cursor: pointer;
   display: inline-block;
   font-size: 13px;
   outline: none;
   overflow: hidden;
   text-align: center;
   vertical-align: top;
   width: 90px;
   height: 90px;
}

.apps a:hover {
   border-color: #e5e5e5;
   background-color: #fcfcfc;
   color: initial;
   text-decoration: none;
}

.apps a + a {
   margin-left: 8px;
}

.apps img {
   display: block;
   margin: 4px auto;
   width: 40px;
   height: 40px;
}

.mat-list,
.mat-nav-list {
   padding-top: 0px;
}

.profile {
   color: #c6cfda;
   cursor: default;
   margin-left: 0.5em;
   margin-right: 1em;
   padding: 3px;
   position: relative;
   white-space: nowrap;
}

.avatar-link {
   background-color: #e5e5e5;
   border-radius: 50%;
   display: block;
   padding: 2px;
   transition: background-color 0.467s cubic-bezier(0.1, 0.9, 0.2, 1) 34ms;
}

.notification-link {
   margin-right: 10px;
   background-color: #ffff;
   border-radius: 50%;
   display: block;
   padding: 1px;
   transition: background-color 0.467s cubic-bezier(0.1, 0.9, 0.2, 1) 34ms;
}

.avatar-link.open {
   background-color: #2ab4c0;
}

.profile img {
   border: none;
   border-radius: 50%;
   cursor: pointer;
   width: 32px;
   height: 32px;
}

.profile .dropdown-menu {
   color: #555;
   left: auto;
   right: -5px;
}

.avatar {
   padding: 10px;
   text-align: center;
}

.avatar img {
   width: 100%;
}

.profile img,
.avatar img {
   display: block;
   margin: auto;
   object-fit: cover;
   transition: opacity 0.4s;
}

img.invisible {
   opacity: 0;
}

.container {
   background: #f4f5f7;
   position: relative;
   cursor: pointer;
   min-height: 96px;
   width: 96px;
}

.container .change {
   background: rgba(0, 0, 0, 0.54);
   color: white;
   font-size: 12px;
   position: absolute;
   bottom: 0;
   left: 0;
   right: 0;
   padding: 3px;
   opacity: 0;
   text-align: center;
   transition: opacity 0.2s;
}

.container:hover .change {
   opacity: 1;
}

.notification-info {
   line-height: 1.6;
   margin-bottom: 8px;
   padding: 5px 5px 5px 5px;
   width: 400px;
}

.user-info {
   line-height: 1.6;
   margin-bottom: 8px;
   padding: 5px 16px 12px 5px;
   width: 200px;
}

.user-info .name {
   color: #222;
   font-size: 18px;
}

.headernotofication {
   padding-left: 8px;
   font-size: 20px;
   font-weight: bold;
}

.recent {
   padding-left: 8px;
   font-size: 18px;
   font-weight: bold;
   color: #8c9197;
}

.badge {
   font-size: 2px;
}

.notification-link .badge {
   position: absolute;
   margin-left: -12px;
   margin-top: -7px;
   padding: 2px 5px;
   border-radius: 50%;
   background-color: red;
   color: white;
}

.separator {
   margin-top: 10px;
   margin-bottom: 10px;
}

.notificationcss {
   padding-top: 5px;
   padding-bottom: 5px;
   color: #222;
   font-size: 16px;
   padding-left: 8px;
   cursor: pointer;
}

.notificationcss:hover {
   background-color: #f7f8fa;
}

.user-info .desc {
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
}

.user-info .quota {
   background-color: #f4f5f7;
   margin-top: 12px;
   margin-bottom: 4px;
}

.user-info .used {
   background-color: #8bc34a;
   height: 3px;
}

.user-info .used50 {
   background-color: #00bcd4;
}

.user-info .used80 {
   background-color: #ba68c8;
}

.user-info .used90 {
   background-color: #ffa726;
}

.user-info .used98 {
   background-color: #ef5350;
}

.quota-info {
   font-size: 12px;
}

.left-nav nav {
   overflow-y: auto;
   padding: 16px 0;
}

::ng-deep .left-nav nav i.fa-caret-right {
   opacity: 0;
   transition: transform 0.3s, opacity 0.8s;
}

::ng-deep .left-nav:hover nav i.fa-caret-right {
   opacity: 1;
}

.content-loader {
   z-index: 1000;
   position: fixed;
   top: 50px;
   right: 0;
   bottom: 0;
   left: 240px;
   pointer-events: none;
}

.content-container {
   flex: 1;
   padding: 50px 0 50px 240px;
   position: relative;
   transition: padding-left 0.4s;
}

::ng-deep .full-width .left-nav {
   margin-left: -240px;
}

::ng-deep .full-width .content-loader {
   visibility: hidden;
}

::ng-deep .full-width .content-container {
   padding-left: 0;
}

footer {
   background-color: white;
   color: #aaa;
   position: fixed;
   left: 240px;
   right: 0;
   bottom: 0;
   transition: left 0.4s;
   z-index: 5;
}

::ng-deep .gray footer {
   background-color: #f7f8fa;
}

::ng-deep .full-width footer {
   left: 0;
}

::ng-deep .full-width footer ul {
   max-width: 999px;
   padding: 10px 15px;
}

footer > ul {
   border-top: 1px solid #eaeaea;
   font-size: 0;
   list-style: none;
   margin: 0 auto;
   padding: 10px 20px;
}

footer > ul > li {
   display: inline-block;
   font-size: 12px;
}

footer > ul > li:not(:first-child):not(:last-child):before {
   content: "|";
   color: #d5d5d5;
   padding: 0 0.5em;
}

footer a {
   color: #777;
   cursor: pointer;
}

footer a:hover {
   color: #3d464d;
}

footer .language {
   color: #777;
   float: right;
}

footer .language .fa {
   font-size: 16px;
   margin-right: 5px;
   vertical-align: text-bottom;
}

.overlay {
   height: 100%;
   width: 0;
   position: fixed;
   z-index: 1;
   top: 0;
   left: 0;
   background-color: rgb(0, 0, 0);
   background-color: rgba(0, 0, 0, 0.9);
   overflow-x: hidden;
   transition: 0.5s;
}

.overlay-content {
   position: relative;
   top: 25%;
   width: 100%;
   text-align: center;
   margin-top: 30px;
}

.overlay a {
   padding: 8px;
   text-decoration: none;
   font-size: 20px;
   color: #818181;
   display: block;
   transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
   color: #f4f5f7;
}

.overlay .closebtn {
   position: absolute;
   top: 20px;
   right: 45px;
   font-size: 30px;
}

@media screen and (max-height: 450px) {
   .overlay a {
      font-size: 20px;
   }

   .overlay .closebtn {
      font-size: 40px;
      top: 15px;
      right: 35px;
   }
}

/* The Modal (background) */

.modal {
   display: none;
   /* Hidden by default */
   position: fixed;
   /* Stay in place */
   z-index: 8;
   /* Sit on top */
   left: 0;
   top: 0;
   width: 100%;
   /* Full width */
   height: 100%;
   /* Full height */
   overflow: auto;
   /* Enable scroll if needed */
   background-color: rgb(0, 0, 0);
   /* Fallback color */
   background-color: rgba(0, 0, 0, 0.4);
   /* Black w/ opacity */
   padding-top: 60px;
}

/* Modal Content/Box */

.modal-content {
   background-color: #fefefe;
   margin: 5% auto 15% auto;
   /* 5% from the top, 15% from the bottom and centered */
   border: 1px solid #888;
   width: 25%;
   /* Could be more or less, depending on screen size */
}

/* The Close Button (x) */

.close {
   position: absolute;
   right: 35px;
   top: 15px;
   color: #000;
   font-size: 14px;
   font-weight: bold;
}

.close:hover,
.close:focus {
   color: #2ea8ed;
   cursor: pointer;
}

/* Change styles for cancel button and signup button on extra small screens */

@media screen and (max-width: 300px) {
   .cancelbtn,
   .signupbtn {
      width: 100%;
   }
}

#changepsw {
   display: none;
}

.modal-content {
   border-color: transparent;
   border-radius: 0;
   padding: 10px 30px;
}

#changepsw h3 {
   margin: 0.5em 0;
   text-align: left;
}

.forgot-instruction {
   display: block;
   text-align: left;
}

#changepsw input {
   display: block;
   margin: 0.1em auto 0.5em;
   padding: 5px;
   width: 100%;
   border-radius: 5px;
}

.primary-button {
   background-color: #2ea8ed;
   border: none;
   color: white;
   cursor: pointer;
   font-weight: 600;
   float: right;
   margin: 1em 0 5px;
   padding: 8px 20px;
   outline: none;
   transition: background-color 0.4s;
   border-radius: 5px;
}

.primary-button:hover {
   background-color: #2997d5;
}

.primary-button:active {
   background-color: #1579b0;
}

.cancel-button {
   background: none;
   border: none;
   cursor: pointer;
   font-weight: 600;
   float: right;
   margin: 1em 10px 5px 0;
   padding: 8px 20px;
   outline: none;
   transition: background-color 0.4s;
}

.cancel-button:hover {
   background-color: #f4f5f7;
}

.cancel-button:active {
   background-color: #e5e5e5;
}

.footer_modal {
   text-align: right;
   margin-top: -15px;
   /*margin: 5px*/
}

.footer_modal button {
   /*font-family: 'Open Sans';*/
   /*font-weight: bold;*/
   margin-top: 10px;
}

#footerbutton {
   border-top: 1px solid #364150;
   margin-top: 10px;
}

.header_modal {
   /*border-bottom: 1px solid #364150;*/
   border-bottom: 1px solid #999;
}

.menu_sign {
   border-right: solid 1px rgb(231, 231, 231);
}

#cookie-notice {
   color: #fff;
   background-color: #2ab4c0;
   display: block;
   position: fixed;
   min-width: 100%;
   height: auto;
   z-index: 100000;
   line-height: 20px;
   left: 0;
   text-align: center;
}

.cn-bottom {
   bottom: 0;
}

.cookie-notice-container {
   padding: 10px;
   text-align: center;
   width: 100%;
   box-sizing: border-box;
   display: flex;
   justify-content: center;
}

.cookie-notice-container > div {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 20px;
}

#cookie-notice .cn-button {
   border-radius: 4px;
   border: none;
   background-color: #fff;
   color: #2ab4c0;
   cursor: pointer;
   font-size: 12px;
   margin-left: 1em;
   padding: 4px 16px;
   outline: none;
   transition: background-color 0.4s, color 0.4s;
}

#cookie-notice .cn-button:hover {
   background-color: rgba(255, 255, 255, 0.8);
}

#cookie-notice .cn-button:active {
   background-color: rgba(0, 0, 0, 0.2);
   color: #fff;
}

#cookie-notice {
   color: #fff;
   background-color: #2ab4c0;
   display: block;
   position: fixed;
   min-width: 100%;
   height: auto;
   z-index: 100000;
   line-height: 20px;
   left: 0;
   text-align: center;
}

.cn-bottom {
   bottom: 0;
}

.cookie-notice-container {
   padding: 10px;
   text-align: center;
   width: 100%;
   box-sizing: border-box;
   display: flex;
   justify-content: center;
}

.cookie-notice-container > div {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 20px;
}

#cookie-notice .cn-button {
   border-radius: 4px;
   border: none;
   background-color: #fff;
   color: #2ab4c0;
   cursor: pointer;
   font-size: 12px;
   margin-left: 1em;
   padding: 4px 16px;
   outline: none;
   transition: background-color 0.4s, color 0.4s;
}

#cookie-notice .cn-button:hover {
   background-color: rgba(255, 255, 255, 0.8);
}

#cookie-notice .cn-button:active {
   background-color: rgba(0, 0, 0, 0.2);
   color: #fff;
}

#cookie-notice {
   color: #fff;
   background-color: #2ab4c0;
   display: block;
   position: fixed;
   min-width: 100%;
   height: auto;
   z-index: 100000;
   line-height: 20px;
   left: 0;
   text-align: center;
}

.cn-bottom {
   bottom: 0;
}

.cookie-notice-container {
   padding: 10px;
   text-align: center;
   width: 100%;
   box-sizing: border-box;
   display: flex;
   justify-content: center;
}

.cookie-notice-container > div {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 20px;
}

#cookie-notice .cn-button {
   border-radius: 4px;
   border: none;
   background-color: #fff;
   color: #2ab4c0;
   cursor: pointer;
   font-size: 12px;
   margin-left: 1em;
   padding: 4px 16px;
   outline: none;
   transition: background-color 0.4s, color 0.4s;
}

#cookie-notice .cn-button:hover {
   background-color: rgba(255, 255, 255, 0.8);
}

#cookie-notice .cn-button:active {
   background-color: rgba(0, 0, 0, 0.2);
   color: #fff;
}

.router-outlet {
   overflow: hidden;
}

/* override material paginator page switch*/
::ng-deep .mat-paginator-range-label {
   margin: 8px !important;
}

.disabled {
   background: #999 !important;
}

::ng-deep.line-broken-tooltip {
   white-space: pre-line;
}

::ng-deep.rightIcon img {
   position: absolute;
   top: calc(50% - 40px);
   right: -12px;
   width: 28px;
   height: 28px;
   display: flex;
   align-items: center;
   justify-content: center;
   /*box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5)*/
}
`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;GACG,YAAY;GACZ;MACG,sBAAsB;MACtB,gBAAgB;MAChB,eAAe;MACf,OAAO;MACP,MAAM;MACN,QAAQ;MACR,YAAY;MACZ,UAAU;MACV,UAAU;GACb;AACH;;AAEA;GACG,iBAAiB;GACjB,eAAe;AAClB;;AAEA;GACG,WAAW;GACX;MACG,sBAAsB;MACtB,eAAe;MACf,OAAO;MACP,MAAM;MACN,YAAY;MACZ,UAAU;MACV,UAAU;MACV,WAAW;GACd;AACH;;AAEA;GACG,aAAa;GACb,4BAA4B;AAC/B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,6BAA6B;AAChC;;AAEA;GACG,wCAAwC;AAC3C;;AAEA,yCAAyC;AACzC;GACG,eAAe;GACf,WAAW;GACX,OAAO;GACP,QAAQ;GACR,6DAA6D;GAC7D,WAAW;GACX,eAAe;GACf,yCAAyC;GACzC,gCAAgC;AACnC;;AAEA;GACG;MACG,2BAA2B;MAC3B,UAAU;GACb;GACA;MACG,wBAAwB;MACxB,UAAU;GACb;AACH;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,kBAAkB;GAClB,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,WAAW;GACX,YAAY;GACZ,cAAc;AACjB;;AAEA;GACG,OAAO;GACP,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;GAChB,eAAe;GACf,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,SAAS;GACT,eAAe;GACf,aAAa;AAChB;;AAEA;GACG,eAAe;GACf,SAAS;GACT,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,cAAc;GACd,uBAAuB;GACvB,YAAY;GACZ,WAAW;GACX,eAAe;GACf,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;GAClB,sCAAsC;GACtC,aAAa;GACb,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;GACG,2CAA2C;AAC9C;;AAEA;GACG,eAAe;GACf,WAAW;GACX,YAAY;AACf;;AAEA;GACG;MACG,kBAAkB;GACrB;;GAEA;MACG,kBAAkB;GACrB;;GAEA;MACG,eAAe;MACf,WAAW;MACX,YAAY;GACf;;GAEA;MACG,eAAe;MACf,kBAAkB;GACrB;;GAEA;MACG,eAAe;GAClB;;GAEA;MACG,eAAe;GAClB;;GAEA;MACG,gBAAgB;GACnB;AACH;;AAEA;GACG,YAAY;AACf;;AAEA;GACG,yBAAyB;GACzB,WAAW;GACX,eAAe;GACf,WAAW;GACX,YAAY;GACZ,uEAAuE;GACvE,yBAAiB;WAAjB,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,YAAY;GACZ,kBAAkB;GAClB,aAAa;GACb,yBAAiB;WAAjB,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,UAAU;GACV,YAAY;AACf;;AAEA;GACG,eAAe;GACf,sBAAsB;AACzB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,6BAA6B;GAC7B,kBAAkB;GAClB,eAAe;GACf,qBAAqB;GACrB,eAAe;GACf,aAAa;GACb,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;GACnB,WAAW;GACX,YAAY;AACf;;AAEA;GACG,qBAAqB;GACrB,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,gBAAgB;GAChB,WAAW;GACX,YAAY;AACf;;AAEA;;GAEG,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,eAAe;GACf,kBAAkB;GAClB,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,cAAc;GACd,YAAY;GACZ,uEAAuE;AAC1E;;AAEA;GACG,kBAAkB;GAClB,uBAAuB;GACvB,kBAAkB;GAClB,cAAc;GACd,YAAY;GACZ,uEAAuE;AAC1E;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,YAAY;GACZ,kBAAkB;GAClB,eAAe;GACf,WAAW;GACX,YAAY;AACf;;AAEA;GACG,WAAW;GACX,UAAU;GACV,WAAW;AACd;;AAEA;GACG,aAAa;GACb,kBAAkB;AACrB;;AAEA;GACG,WAAW;AACd;;AAEA;;GAEG,cAAc;GACd,YAAY;GACZ,iBAAiB;GACjB,wBAAwB;AAC3B;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,mBAAmB;GACnB,kBAAkB;GAClB,eAAe;GACf,gBAAgB;GAChB,WAAW;AACd;;AAEA;GACG,+BAA+B;GAC/B,YAAY;GACZ,eAAe;GACf,kBAAkB;GAClB,SAAS;GACT,OAAO;GACP,QAAQ;GACR,YAAY;GACZ,UAAU;GACV,kBAAkB;GAClB,wBAAwB;AAC3B;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,wBAAwB;GACxB,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,0BAA0B;GAC1B,YAAY;AACf;;AAEA;GACG,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,iBAAiB;GACjB,eAAe;GACf,iBAAiB;AACpB;;AAEA;GACG,iBAAiB;GACjB,eAAe;GACf,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,kBAAkB;GAClB,kBAAkB;GAClB,gBAAgB;GAChB,gBAAgB;GAChB,kBAAkB;GAClB,qBAAqB;GACrB,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;GACnB,WAAW;GACX,eAAe;GACf,iBAAiB;GACjB,eAAe;AAClB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,gBAAgB;GAChB,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,WAAW;AACd;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,gBAAgB;GAChB,eAAe;AAClB;;AAEA;GACG,UAAU;GACV,wCAAwC;AAC3C;;AAEA;GACG,UAAU;AACb;;AAEA;GACG,aAAa;GACb,eAAe;GACf,SAAS;GACT,QAAQ;GACR,SAAS;GACT,WAAW;GACX,oBAAoB;AACvB;;AAEA;GACG,OAAO;GACP,0BAA0B;GAC1B,kBAAkB;GAClB,6BAA6B;AAChC;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,uBAAuB;GACvB,WAAW;GACX,eAAe;GACf,WAAW;GACX,QAAQ;GACR,SAAS;GACT,qBAAqB;GACrB,UAAU;AACb;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,OAAO;AACV;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,6BAA6B;GAC7B,YAAY;GACZ,gBAAgB;GAChB,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,qBAAqB;GACrB,eAAe;AAClB;;AAEA;GACG,YAAY;GACZ,cAAc;GACd,gBAAgB;AACnB;;AAEA;GACG,WAAW;GACX,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA;GACG,eAAe;GACf,iBAAiB;GACjB,2BAA2B;AAC9B;;AAEA;GACG,YAAY;GACZ,QAAQ;GACR,eAAe;GACf,UAAU;GACV,MAAM;GACN,OAAO;GACP,8BAA8B;GAC9B,oCAAoC;GACpC,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,kBAAkB;GAClB,QAAQ;GACR,WAAW;GACX,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,YAAY;GACZ,qBAAqB;GACrB,eAAe;GACf,cAAc;GACd,cAAc;GACd,gBAAgB;AACnB;;AAEA;;GAEG,cAAc;AACjB;;AAEA;GACG,kBAAkB;GAClB,SAAS;GACT,WAAW;GACX,eAAe;AAClB;;AAEA;GACG;MACG,eAAe;GAClB;;GAEA;MACG,eAAe;MACf,SAAS;MACT,WAAW;GACd;AACH;;AAEA,2BAA2B;;AAE3B;GACG,aAAa;GACb,sBAAsB;GACtB,eAAe;GACf,kBAAkB;GAClB,UAAU;GACV,eAAe;GACf,OAAO;GACP,MAAM;GACN,WAAW;GACX,eAAe;GACf,YAAY;GACZ,gBAAgB;GAChB,cAAc;GACd,4BAA4B;GAC5B,8BAA8B;GAC9B,mBAAmB;GACnB,oCAAoC;GACpC,qBAAqB;GACrB,iBAAiB;AACpB;;AAEA,sBAAsB;;AAEtB;GACG,yBAAyB;GACzB,wBAAwB;GACxB,sDAAsD;GACtD,sBAAsB;GACtB,UAAU;GACV,oDAAoD;AACvD;;AAEA,yBAAyB;;AAEzB;GACG,kBAAkB;GAClB,WAAW;GACX,SAAS;GACT,WAAW;GACX,eAAe;GACf,iBAAiB;AACpB;;AAEA;;GAEG,cAAc;GACd,eAAe;AAClB;;AAEA,6EAA6E;;AAE7E;GACG;;MAEG,WAAW;GACd;AACH;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,yBAAyB;GACzB,gBAAgB;GAChB,kBAAkB;AACrB;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,gBAAgB;AACnB;;AAEA;GACG,cAAc;GACd,wBAAwB;GACxB,YAAY;GACZ,WAAW;GACX,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;GACzB,YAAY;GACZ,YAAY;GACZ,eAAe;GACf,gBAAgB;GAChB,YAAY;GACZ,iBAAiB;GACjB,iBAAiB;GACjB,aAAa;GACb,iCAAiC;GACjC,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,gBAAgB;GAChB,YAAY;GACZ,eAAe;GACf,gBAAgB;GAChB,YAAY;GACZ,sBAAsB;GACtB,iBAAiB;GACjB,aAAa;GACb,iCAAiC;AACpC;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,4BAA4B;GAC5B,qBAAqB;GACrB,gBAAgB;AACnB;;AAEA;GACG,6BAA6B;GAC7B,gBAAgB;AACnB;;AAEA;GACG,oCAAoC;GACpC,6BAA6B;AAChC;;AAEA;GACG,0CAA0C;AAC7C;;AAEA;GACG,WAAW;GACX,yBAAyB;GACzB,cAAc;GACd,eAAe;GACf,eAAe;GACf,YAAY;GACZ,eAAe;GACf,iBAAiB;GACjB,OAAO;GACP,kBAAkB;AACrB;;AAEA;GACG,SAAS;AACZ;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,WAAW;GAGX,sBAAsB;GACtB,aAAa;GACb,uBAAuB;AAC1B;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,eAAe;AAClB;;AAEA;GACG,kBAAkB;GAClB,YAAY;GACZ,sBAAsB;GACtB,cAAc;GACd,eAAe;GACf,eAAe;GACf,gBAAgB;GAChB,iBAAiB;GACjB,aAAa;GACb,6CAA6C;AAChD;;AAEA;GACG,0CAA0C;AAC7C;;AAEA;GACG,oCAAoC;GACpC,WAAW;AACd;;AAEA;GACG,WAAW;GACX,yBAAyB;GACzB,cAAc;GACd,eAAe;GACf,eAAe;GACf,YAAY;GACZ,eAAe;GACf,iBAAiB;GACjB,OAAO;GACP,kBAAkB;AACrB;;AAEA;GACG,SAAS;AACZ;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,WAAW;GAGX,sBAAsB;GACtB,aAAa;GACb,uBAAuB;AAC1B;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,eAAe;AAClB;;AAEA;GACG,kBAAkB;GAClB,YAAY;GACZ,sBAAsB;GACtB,cAAc;GACd,eAAe;GACf,eAAe;GACf,gBAAgB;GAChB,iBAAiB;GACjB,aAAa;GACb,6CAA6C;AAChD;;AAEA;GACG,0CAA0C;AAC7C;;AAEA;GACG,oCAAoC;GACpC,WAAW;AACd;;AAEA;GACG,WAAW;GACX,yBAAyB;GACzB,cAAc;GACd,eAAe;GACf,eAAe;GACf,YAAY;GACZ,eAAe;GACf,iBAAiB;GACjB,OAAO;GACP,kBAAkB;AACrB;;AAEA;GACG,SAAS;AACZ;;AAEA;GACG,aAAa;GACb,kBAAkB;GAClB,WAAW;GAGX,sBAAsB;GACtB,aAAa;GACb,uBAAuB;AAC1B;;AAEA;GACG,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,eAAe;AAClB;;AAEA;GACG,kBAAkB;GAClB,YAAY;GACZ,sBAAsB;GACtB,cAAc;GACd,eAAe;GACf,eAAe;GACf,gBAAgB;GAChB,iBAAiB;GACjB,aAAa;GACb,6CAA6C;AAChD;;AAEA;GACG,0CAA0C;AAC7C;;AAEA;GACG,oCAAoC;GACpC,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA,2CAA2C;AAC3C;GACG,sBAAsB;AACzB;;AAEA;GACG,2BAA2B;AAC9B;;AAEA;GACG,qBAAqB;AACxB;;AAEA;GACG,kBAAkB;GAClB,qBAAqB;GACrB,YAAY;GACZ,WAAW;GACX,YAAY;GACZ,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,kDAAkD;AACrD","sourcesContent":["@media (min-width: 992px) {\n   /* desktop */\n   .header {\n      background-color: #fff;\n      min-width: 500px;\n      position: fixed;\n      left: 0;\n      top: 0;\n      right: 0;\n      height: 50px;\n      padding: 0;\n      z-index: 8;\n   }\n}\n\n.notification {\n   margin-right: 5px;\n   cursor: pointer;\n}\n\n@media (min-width: 0px) and (max-width: 992px) {\n   /* mobile */\n   .header {\n      background-color: #fff;\n      position: fixed;\n      left: 0;\n      top: 0;\n      height: 50px;\n      padding: 0;\n      z-index: 8;\n      width: 100%;\n   }\n}\n\n::ng-deep .login-page header {\n   display: none;\n   padding-top: 40px !important;\n}\n\n::ng-deep .no-header {\n   background-color: #fafbfd;\n}\n\n::ng-deep .no-header .header {\n   background-color: transparent;\n}\n\n::ng-deep .header-shadow .header {\n   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n/* Browser Compatibility Warning Banner */\n.browser-warning-banner {\n   position: fixed;\n   bottom: 0px;\n   left: 0;\n   right: 0;\n   background: linear-gradient(135deg, #2ab4c0 0%, #007c9e 100%);\n   color: #fff;\n   z-index: 100000;\n   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n   animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n   from {\n      transform: translateY(100%);\n      opacity: 0;\n   }\n   to {\n      transform: translateY(0);\n      opacity: 1;\n   }\n}\n\n.browser-warning-content {\n   display: flex;\n   align-items: center;\n   padding: 16px 24px;\n   max-width: 1400px;\n   margin: 0 auto;\n}\n\n.warning-icon {\n   flex-shrink: 0;\n   margin-right: 16px;\n}\n\n.warning-icon mat-icon {\n   font-size: 32px;\n   width: 32px;\n   height: 32px;\n   color: #fff8dc;\n}\n\n.warning-message {\n   flex: 1;\n   line-height: 1.5;\n}\n\n.warning-message strong {\n   font-weight: 600;\n   font-size: 16px;\n   display: block;\n   margin-bottom: 8px;\n}\n\n.warning-message p {\n   margin: 0;\n   font-size: 14px;\n   opacity: 0.95;\n}\n\n.warning-message p strong {\n   display: inline;\n   margin: 0;\n   color: #fff8dc;\n   font-size: 14px;\n}\n\n.warning-close {\n   flex-shrink: 0;\n   background: transparent;\n   border: none;\n   color: #fff;\n   cursor: pointer;\n   padding: 8px;\n   margin-left: 16px;\n   border-radius: 50%;\n   transition: background-color 0.2s ease;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n}\n\n.warning-close:hover {\n   background-color: rgba(255, 255, 255, 0.15);\n}\n\n.warning-close mat-icon {\n   font-size: 24px;\n   width: 24px;\n   height: 24px;\n}\n\n@media (max-width: 768px) {\n   .browser-warning-content {\n      padding: 12px 16px;\n   }\n\n   .warning-icon {\n      margin-right: 12px;\n   }\n\n   .warning-icon mat-icon {\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n   }\n\n   .warning-message strong {\n      font-size: 14px;\n      margin-bottom: 6px;\n   }\n\n   .warning-message p {\n      font-size: 12px;\n   }\n\n   .warning-message p strong {\n      font-size: 12px;\n   }\n\n   .warning-close {\n      margin-left: 8px;\n   }\n}\n\n.brand {\n   height: 50px;\n}\n\n.brand .apps-button {\n   background-color: #2ab4c0;\n   color: #fff;\n   cursor: pointer;\n   width: 50px;\n   height: 50px;\n   transition: background-color 0.467s cubic-bezier(0.1, 0.9, 0.2, 1) 34ms;\n   user-select: none;\n}\n\n.brand .apps-button:hover {\n   background-color: #007c9e;\n}\n\n.brand .logo {\n   align-items: center;\n}\n\n.brand .logo img {\n   height: 18px;\n   margin: 3px 30px 0;\n   outline: none;\n   user-select: none;\n}\n\n.brand .logo .separator {\n   background-color: #e5e5e5;\n   border-radius: 2px;\n   width: 1px;\n   height: 30px;\n}\n\n.brand .logo span {\n   font-size: 20px;\n   padding: 0 30px 0 20px;\n}\n\n.apps {\n   padding: 8px 16px;\n}\n\n.apps a {\n   border: 1px solid transparent;\n   border-radius: 2px;\n   cursor: pointer;\n   display: inline-block;\n   font-size: 13px;\n   outline: none;\n   overflow: hidden;\n   text-align: center;\n   vertical-align: top;\n   width: 90px;\n   height: 90px;\n}\n\n.apps a:hover {\n   border-color: #e5e5e5;\n   background-color: #fcfcfc;\n   color: initial;\n   text-decoration: none;\n}\n\n.apps a + a {\n   margin-left: 8px;\n}\n\n.apps img {\n   display: block;\n   margin: 4px auto;\n   width: 40px;\n   height: 40px;\n}\n\n.mat-list,\n.mat-nav-list {\n   padding-top: 0px;\n}\n\n.profile {\n   color: #c6cfda;\n   cursor: default;\n   margin-left: 0.5em;\n   margin-right: 1em;\n   padding: 3px;\n   position: relative;\n   white-space: nowrap;\n}\n\n.avatar-link {\n   background-color: #e5e5e5;\n   border-radius: 50%;\n   display: block;\n   padding: 2px;\n   transition: background-color 0.467s cubic-bezier(0.1, 0.9, 0.2, 1) 34ms;\n}\n\n.notification-link {\n   margin-right: 10px;\n   background-color: #ffff;\n   border-radius: 50%;\n   display: block;\n   padding: 1px;\n   transition: background-color 0.467s cubic-bezier(0.1, 0.9, 0.2, 1) 34ms;\n}\n\n.avatar-link.open {\n   background-color: #2ab4c0;\n}\n\n.profile img {\n   border: none;\n   border-radius: 50%;\n   cursor: pointer;\n   width: 32px;\n   height: 32px;\n}\n\n.profile .dropdown-menu {\n   color: #555;\n   left: auto;\n   right: -5px;\n}\n\n.avatar {\n   padding: 10px;\n   text-align: center;\n}\n\n.avatar img {\n   width: 100%;\n}\n\n.profile img,\n.avatar img {\n   display: block;\n   margin: auto;\n   object-fit: cover;\n   transition: opacity 0.4s;\n}\n\nimg.invisible {\n   opacity: 0;\n}\n\n.container {\n   background: #f4f5f7;\n   position: relative;\n   cursor: pointer;\n   min-height: 96px;\n   width: 96px;\n}\n\n.container .change {\n   background: rgba(0, 0, 0, 0.54);\n   color: white;\n   font-size: 12px;\n   position: absolute;\n   bottom: 0;\n   left: 0;\n   right: 0;\n   padding: 3px;\n   opacity: 0;\n   text-align: center;\n   transition: opacity 0.2s;\n}\n\n.container:hover .change {\n   opacity: 1;\n}\n\n.notification-info {\n   line-height: 1.6;\n   margin-bottom: 8px;\n   padding: 5px 5px 5px 5px;\n   width: 400px;\n}\n\n.user-info {\n   line-height: 1.6;\n   margin-bottom: 8px;\n   padding: 5px 16px 12px 5px;\n   width: 200px;\n}\n\n.user-info .name {\n   color: #222;\n   font-size: 18px;\n}\n\n.headernotofication {\n   padding-left: 8px;\n   font-size: 20px;\n   font-weight: bold;\n}\n\n.recent {\n   padding-left: 8px;\n   font-size: 18px;\n   font-weight: bold;\n   color: #8c9197;\n}\n\n.badge {\n   font-size: 2px;\n}\n\n.notification-link .badge {\n   position: absolute;\n   margin-left: -12px;\n   margin-top: -7px;\n   padding: 2px 5px;\n   border-radius: 50%;\n   background-color: red;\n   color: white;\n}\n\n.separator {\n   margin-top: 10px;\n   margin-bottom: 10px;\n}\n\n.notificationcss {\n   padding-top: 5px;\n   padding-bottom: 5px;\n   color: #222;\n   font-size: 16px;\n   padding-left: 8px;\n   cursor: pointer;\n}\n\n.notificationcss:hover {\n   background-color: #f7f8fa;\n}\n\n.user-info .desc {\n   overflow: hidden;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n}\n\n.user-info .quota {\n   background-color: #f4f5f7;\n   margin-top: 12px;\n   margin-bottom: 4px;\n}\n\n.user-info .used {\n   background-color: #8bc34a;\n   height: 3px;\n}\n\n.user-info .used50 {\n   background-color: #00bcd4;\n}\n\n.user-info .used80 {\n   background-color: #ba68c8;\n}\n\n.user-info .used90 {\n   background-color: #ffa726;\n}\n\n.user-info .used98 {\n   background-color: #ef5350;\n}\n\n.quota-info {\n   font-size: 12px;\n}\n\n.left-nav nav {\n   overflow-y: auto;\n   padding: 16px 0;\n}\n\n::ng-deep .left-nav nav i.fa-caret-right {\n   opacity: 0;\n   transition: transform 0.3s, opacity 0.8s;\n}\n\n::ng-deep .left-nav:hover nav i.fa-caret-right {\n   opacity: 1;\n}\n\n.content-loader {\n   z-index: 1000;\n   position: fixed;\n   top: 50px;\n   right: 0;\n   bottom: 0;\n   left: 240px;\n   pointer-events: none;\n}\n\n.content-container {\n   flex: 1;\n   padding: 50px 0 50px 240px;\n   position: relative;\n   transition: padding-left 0.4s;\n}\n\n::ng-deep .full-width .left-nav {\n   margin-left: -240px;\n}\n\n::ng-deep .full-width .content-loader {\n   visibility: hidden;\n}\n\n::ng-deep .full-width .content-container {\n   padding-left: 0;\n}\n\nfooter {\n   background-color: white;\n   color: #aaa;\n   position: fixed;\n   left: 240px;\n   right: 0;\n   bottom: 0;\n   transition: left 0.4s;\n   z-index: 5;\n}\n\n::ng-deep .gray footer {\n   background-color: #f7f8fa;\n}\n\n::ng-deep .full-width footer {\n   left: 0;\n}\n\n::ng-deep .full-width footer ul {\n   max-width: 999px;\n   padding: 10px 15px;\n}\n\nfooter > ul {\n   border-top: 1px solid #eaeaea;\n   font-size: 0;\n   list-style: none;\n   margin: 0 auto;\n   padding: 10px 20px;\n}\n\nfooter > ul > li {\n   display: inline-block;\n   font-size: 12px;\n}\n\nfooter > ul > li:not(:first-child):not(:last-child):before {\n   content: \"|\";\n   color: #d5d5d5;\n   padding: 0 0.5em;\n}\n\nfooter a {\n   color: #777;\n   cursor: pointer;\n}\n\nfooter a:hover {\n   color: #3d464d;\n}\n\nfooter .language {\n   color: #777;\n   float: right;\n}\n\nfooter .language .fa {\n   font-size: 16px;\n   margin-right: 5px;\n   vertical-align: text-bottom;\n}\n\n.overlay {\n   height: 100%;\n   width: 0;\n   position: fixed;\n   z-index: 1;\n   top: 0;\n   left: 0;\n   background-color: rgb(0, 0, 0);\n   background-color: rgba(0, 0, 0, 0.9);\n   overflow-x: hidden;\n   transition: 0.5s;\n}\n\n.overlay-content {\n   position: relative;\n   top: 25%;\n   width: 100%;\n   text-align: center;\n   margin-top: 30px;\n}\n\n.overlay a {\n   padding: 8px;\n   text-decoration: none;\n   font-size: 20px;\n   color: #818181;\n   display: block;\n   transition: 0.3s;\n}\n\n.overlay a:hover,\n.overlay a:focus {\n   color: #f4f5f7;\n}\n\n.overlay .closebtn {\n   position: absolute;\n   top: 20px;\n   right: 45px;\n   font-size: 30px;\n}\n\n@media screen and (max-height: 450px) {\n   .overlay a {\n      font-size: 20px;\n   }\n\n   .overlay .closebtn {\n      font-size: 40px;\n      top: 15px;\n      right: 35px;\n   }\n}\n\n/* The Modal (background) */\n\n.modal {\n   display: none;\n   /* Hidden by default */\n   position: fixed;\n   /* Stay in place */\n   z-index: 8;\n   /* Sit on top */\n   left: 0;\n   top: 0;\n   width: 100%;\n   /* Full width */\n   height: 100%;\n   /* Full height */\n   overflow: auto;\n   /* Enable scroll if needed */\n   background-color: rgb(0, 0, 0);\n   /* Fallback color */\n   background-color: rgba(0, 0, 0, 0.4);\n   /* Black w/ opacity */\n   padding-top: 60px;\n}\n\n/* Modal Content/Box */\n\n.modal-content {\n   background-color: #fefefe;\n   margin: 5% auto 15% auto;\n   /* 5% from the top, 15% from the bottom and centered */\n   border: 1px solid #888;\n   width: 25%;\n   /* Could be more or less, depending on screen size */\n}\n\n/* The Close Button (x) */\n\n.close {\n   position: absolute;\n   right: 35px;\n   top: 15px;\n   color: #000;\n   font-size: 14px;\n   font-weight: bold;\n}\n\n.close:hover,\n.close:focus {\n   color: #2ea8ed;\n   cursor: pointer;\n}\n\n/* Change styles for cancel button and signup button on extra small screens */\n\n@media screen and (max-width: 300px) {\n   .cancelbtn,\n   .signupbtn {\n      width: 100%;\n   }\n}\n\n#changepsw {\n   display: none;\n}\n\n.modal-content {\n   border-color: transparent;\n   border-radius: 0;\n   padding: 10px 30px;\n}\n\n#changepsw h3 {\n   margin: 0.5em 0;\n   text-align: left;\n}\n\n.forgot-instruction {\n   display: block;\n   text-align: left;\n}\n\n#changepsw input {\n   display: block;\n   margin: 0.1em auto 0.5em;\n   padding: 5px;\n   width: 100%;\n   border-radius: 5px;\n}\n\n.primary-button {\n   background-color: #2ea8ed;\n   border: none;\n   color: white;\n   cursor: pointer;\n   font-weight: 600;\n   float: right;\n   margin: 1em 0 5px;\n   padding: 8px 20px;\n   outline: none;\n   transition: background-color 0.4s;\n   border-radius: 5px;\n}\n\n.primary-button:hover {\n   background-color: #2997d5;\n}\n\n.primary-button:active {\n   background-color: #1579b0;\n}\n\n.cancel-button {\n   background: none;\n   border: none;\n   cursor: pointer;\n   font-weight: 600;\n   float: right;\n   margin: 1em 10px 5px 0;\n   padding: 8px 20px;\n   outline: none;\n   transition: background-color 0.4s;\n}\n\n.cancel-button:hover {\n   background-color: #f4f5f7;\n}\n\n.cancel-button:active {\n   background-color: #e5e5e5;\n}\n\n.footer_modal {\n   text-align: right;\n   margin-top: -15px;\n   /*margin: 5px*/\n}\n\n.footer_modal button {\n   /*font-family: 'Open Sans';*/\n   /*font-weight: bold;*/\n   margin-top: 10px;\n}\n\n#footerbutton {\n   border-top: 1px solid #364150;\n   margin-top: 10px;\n}\n\n.header_modal {\n   /*border-bottom: 1px solid #364150;*/\n   border-bottom: 1px solid #999;\n}\n\n.menu_sign {\n   border-right: solid 1px rgb(231, 231, 231);\n}\n\n#cookie-notice {\n   color: #fff;\n   background-color: #2ab4c0;\n   display: block;\n   position: fixed;\n   min-width: 100%;\n   height: auto;\n   z-index: 100000;\n   line-height: 20px;\n   left: 0;\n   text-align: center;\n}\n\n.cn-bottom {\n   bottom: 0;\n}\n\n.cookie-notice-container {\n   padding: 10px;\n   text-align: center;\n   width: 100%;\n   -webkit-box-sizing: border-box;\n   -moz-box-sizing: border-box;\n   box-sizing: border-box;\n   display: flex;\n   justify-content: center;\n}\n\n.cookie-notice-container > div {\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   padding: 0 20px;\n}\n\n#cookie-notice .cn-button {\n   border-radius: 4px;\n   border: none;\n   background-color: #fff;\n   color: #2ab4c0;\n   cursor: pointer;\n   font-size: 12px;\n   margin-left: 1em;\n   padding: 4px 16px;\n   outline: none;\n   transition: background-color 0.4s, color 0.4s;\n}\n\n#cookie-notice .cn-button:hover {\n   background-color: rgba(255, 255, 255, 0.8);\n}\n\n#cookie-notice .cn-button:active {\n   background-color: rgba(0, 0, 0, 0.2);\n   color: #fff;\n}\n\n#cookie-notice {\n   color: #fff;\n   background-color: #2ab4c0;\n   display: block;\n   position: fixed;\n   min-width: 100%;\n   height: auto;\n   z-index: 100000;\n   line-height: 20px;\n   left: 0;\n   text-align: center;\n}\n\n.cn-bottom {\n   bottom: 0;\n}\n\n.cookie-notice-container {\n   padding: 10px;\n   text-align: center;\n   width: 100%;\n   -webkit-box-sizing: border-box;\n   -moz-box-sizing: border-box;\n   box-sizing: border-box;\n   display: flex;\n   justify-content: center;\n}\n\n.cookie-notice-container > div {\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   padding: 0 20px;\n}\n\n#cookie-notice .cn-button {\n   border-radius: 4px;\n   border: none;\n   background-color: #fff;\n   color: #2ab4c0;\n   cursor: pointer;\n   font-size: 12px;\n   margin-left: 1em;\n   padding: 4px 16px;\n   outline: none;\n   transition: background-color 0.4s, color 0.4s;\n}\n\n#cookie-notice .cn-button:hover {\n   background-color: rgba(255, 255, 255, 0.8);\n}\n\n#cookie-notice .cn-button:active {\n   background-color: rgba(0, 0, 0, 0.2);\n   color: #fff;\n}\n\n#cookie-notice {\n   color: #fff;\n   background-color: #2ab4c0;\n   display: block;\n   position: fixed;\n   min-width: 100%;\n   height: auto;\n   z-index: 100000;\n   line-height: 20px;\n   left: 0;\n   text-align: center;\n}\n\n.cn-bottom {\n   bottom: 0;\n}\n\n.cookie-notice-container {\n   padding: 10px;\n   text-align: center;\n   width: 100%;\n   -webkit-box-sizing: border-box;\n   -moz-box-sizing: border-box;\n   box-sizing: border-box;\n   display: flex;\n   justify-content: center;\n}\n\n.cookie-notice-container > div {\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   padding: 0 20px;\n}\n\n#cookie-notice .cn-button {\n   border-radius: 4px;\n   border: none;\n   background-color: #fff;\n   color: #2ab4c0;\n   cursor: pointer;\n   font-size: 12px;\n   margin-left: 1em;\n   padding: 4px 16px;\n   outline: none;\n   transition: background-color 0.4s, color 0.4s;\n}\n\n#cookie-notice .cn-button:hover {\n   background-color: rgba(255, 255, 255, 0.8);\n}\n\n#cookie-notice .cn-button:active {\n   background-color: rgba(0, 0, 0, 0.2);\n   color: #fff;\n}\n\n.router-outlet {\n   overflow: hidden;\n}\n\n/* override material paginator page switch*/\n::ng-deep .mat-paginator-range-label {\n   margin: 8px !important;\n}\n\n.disabled {\n   background: #999 !important;\n}\n\n::ng-deep.line-broken-tooltip {\n   white-space: pre-line;\n}\n\n::ng-deep.rightIcon img {\n   position: absolute;\n   top: calc(50% - 40px);\n   right: -12px;\n   width: 28px;\n   height: 28px;\n   display: flex;\n   align-items: center;\n   justify-content: center;\n   /*box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.5)*/\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
